import { render } from "./category-wizard-mobile.vue?vue&type=template&id=06ace82a&scoped=true&ts=true"
import script from "./category-wizard-mobile.vue?vue&type=script&lang=ts"
export * from "./category-wizard-mobile.vue?vue&type=script&lang=ts"

import "./category-wizard-mobile.vue?vue&type=style&index=0&id=06ace82a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ace82a"]])

export default __exports__